// Initialize addon functionality
document.addEventListener('DOMContentLoaded', function() {
  // Initialize addon containers
  const initAddons = () => {
    const addonContainers = document.querySelectorAll('[data-addon-container]');
    
    addonContainers.forEach(container => {
      if (!container.hasAttribute('data-addons-initialized')) {
        container.setAttribute('data-addons-initialized', 'true');
        new ProductAddonsManager(container);
      }
    });
  };

  // Initialize immediately
  initAddons();

  // Also initialize when new content is loaded
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.matches && node.matches('[data-addon-container]')) {
              if (!node.hasAttribute('data-addons-initialized')) {
                node.setAttribute('data-addons-initialized', 'true');
                new ProductAddonsManager(node);
              }
            }
            // Check child elements too
            const addonContainers = node.querySelectorAll && node.querySelectorAll('[data-addon-container]');
            if (addonContainers) {
              addonContainers.forEach(container => {
                if (!container.hasAttribute('data-addons-initialized')) {
                  container.setAttribute('data-addons-initialized', 'true');
                  new ProductAddonsManager(container);
                }
              });
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// Make ProductAddonsManager available globally
window.ProductAddonsManager = class ProductAddonsManager {
  constructor(container) {
    this.container = container;
    this.selectedAddons = new Map();
    this.init();
  }

  init() {
    // Listen for checkbox changes
    this.container.addEventListener('change', this.handleCheckboxChange.bind(this));
    
    // Listen for add to cart button clicks
    this.setupAddToCartListener();
    
    // Initialize selected addons from form data if any
    this.loadSelectedAddons();
  }

  setupAddToCartListener() {
    // Find the main add to cart button
    const addToCartButton = document.querySelector('[name="add"], [data-add-to-cart], .btn[type="submit"]');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));
    }
    
    // Also listen for form submission
    const addToCartForm = document.querySelector('form[action*="/cart/add"]');
    if (addToCartForm) {
      addToCartForm.addEventListener('submit', this.handleFormSubmit.bind(this));
    }
  }

  handleCheckboxChange(event) {
    if (event.target.matches('[data-addon-checkbox]')) {
      const checkbox = event.target;
      const productId = checkbox.dataset.productId;
      const variantId = checkbox.dataset.variantId;
      const productTitle = checkbox.dataset.productTitle;
      const variantPrice = checkbox.dataset.variantPrice;
      
      const addonCard = checkbox.closest('.product-card');
      
      if (checkbox.checked) {
        this.selectedAddons.set(productId, {
          variantId: variantId,
          productTitle: productTitle,
          variantPrice: variantPrice,
          checkbox: checkbox,
          card: addonCard
        });
        if (addonCard) {
          addonCard.classList.add('selected');
        }
      } else {
        this.selectedAddons.delete(productId);
        if (addonCard) {
          addonCard.classList.remove('selected');
        }
      }
      
      // Dispatch event for other components
      this.container.dispatchEvent(new CustomEvent('addons:changed', {
        detail: { selectedAddons: Array.from(this.selectedAddons.values()) }
      }));
    }
  }

  loadSelectedAddons() {
    // Check if there are any pre-selected addons from form data
    const checkboxes = this.container.querySelectorAll('[data-addon-checkbox]');
    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        const productId = checkbox.dataset.productId;
        const variantId = checkbox.dataset.variantId;
        const productTitle = checkbox.dataset.productTitle;
        const variantPrice = checkbox.dataset.variantPrice;
        const addonCard = checkbox.closest('.product-card');
        
        this.selectedAddons.set(productId, {
          variantId: variantId,
          productTitle: productTitle,
          variantPrice: variantPrice,
          checkbox: checkbox,
          card: addonCard
        });
        if (addonCard) {
          addonCard.classList.add('selected');
        }
      }
    });
  }

  handleAddToCart(event) {
    if (this.selectedAddons.size > 0) {
      // Prevent default form submission
      event.preventDefault();
      event.stopPropagation();
      
      // Add selected addons to the cart
      this.addAddonsToCart();
    }
  }

  handleFormSubmit(event) {
    // This will be called when the form is submitted
    if (this.selectedAddons.size > 0) {
      // Prevent the default form submission
      event.preventDefault();
      event.stopPropagation();
      
      // Add selected addons to the cart
      this.addAddonsToCart();
    }
  }

  async addAddonsToCart() {
    try {
      // Get the main product from the form
      const form = document.querySelector('form[action*="/cart/add"]');
      if (!form) {
        console.error('No add to cart form found');
        return;
      }
      
      const formData = new FormData(form);
      const mainProductId = formData.get('id');
      const mainProductQuantity = formData.get('quantity') || 1;
      
      if (!mainProductId) {
        console.error('No main product ID found');
        return;
      }
      
      // Prepare items array
      const items = [];
      
      // Add main product
      items.push({
        id: mainProductId,
        quantity: parseInt(mainProductQuantity)
      });
      
      // Add selected addons
      this.selectedAddons.forEach((addon, productId) => {
        items.push({
          id: addon.variantId,
          quantity: 1,
          properties: {
            '_addon_product': productId,
            '_addon_title': addon.productTitle
          }
        });
      });
      
      // Get sections to bundle (following the theme pattern)
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );
      
      // Prepare request body (following products-bundle.js pattern)
      const body = JSON.stringify({
        items: items,
        sections: sectionsToBundle,
        sections_url: window.location.pathname,
      });
      
      // Get fetch config (following the theme pattern)
      const config = FoxTheme.utils.fetchConfig('javascript');
      config.body = body;
      
      // Submit to cart
      const response = await fetch(`${FoxTheme.routes.cart_add_url}`, config);
      const parsedState = await response.json();
      
      if (parsedState.status) {
        // Handle cart error
        console.error('Cart error:', parsedState);
        alert(parsedState.description || 'Error adding items to cart');
        return;
      }
      
      // Update cart state (following the theme pattern)
      const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
      cartJson['sections'] = parsedState['sections'];
      
      // Update cart state
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
      document.querySelector(".cart-drawer-button").click();
     document.dispatchEvent(
    new CustomEvent('product-ajax:added', {
      detail: {
        product: parsedState,
      },
    })
  );
      
      // Clear selection
      this.clearSelection();
      
      // Show cart drawer (following the theme pattern)
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.showCartDrawer) {
        cartDrawer.showCartDrawer();
      }
      
    } catch (error) {
      console.error('Error adding addons to cart:', error);
      alert('Error adding items to cart. Please try again.');
    }
  }

  getSelectedAddons() {
    return Array.from(this.selectedAddons.values());
  }

  clearSelection() {
    this.selectedAddons.forEach((addon, productId) => {
      addon.checkbox.checked = false;
      if (addon.card) {
        addon.card.classList.remove('selected');
      }
    });
    this.selectedAddons.clear();
  }
}